import React from 'react';
import {Switch} from '@blueprintjs/core';
import styled from 'styled-components';

import {StyledFormGroup} from './shared';


const CompactFormGroup = styled(StyledFormGroup)`
    &[class*="bp"][class*="-form-group"] {
        margin-bottom: 0;
    }
`;

const SwitchField = ({label, value, disabled, error, onChange}) => {
    return (
        <CompactFormGroup helperText={error?.message} intent={error ? 'danger' : 'none'}>
            <Switch
                label={label}
                checked={!!value}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
            />
        </CompactFormGroup>
    );
};

export {SwitchField};
